import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { Subject } from "rxjs";
import { ComponentBase } from "../../../helpers/ComponentBase";
import { EGalleryCommand } from "../../../model/gallery/EGalleryCommand";
import { IGalleryCommand } from "../../../model/gallery/IGalleryCommand";

@Component({
	selector: "attachments-popover",
	templateUrl: "./attachmentsPopover.component.html",
	styleUrls: ["./attachmentsPopover.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class AttachmentsPopoverComponent extends ComponentBase {
	//#region PROPERTIES

	@Input() public galleryCommandSubject: Subject<IGalleryCommand>;

	private mbAreFormsVisible = false;
	public get areFormsVisible(): boolean {
		return this.mbAreFormsVisible;
	}
	public set areFormsVisible(pbValue: boolean) {
		if (pbValue !== this.mbAreFormsVisible) {
			this.mbAreFormsVisible = pbValue;
			this.detectChanges();
		}
	}

	//#endregion

	//#region METHODS

	public takePicture(): void {
		this.galleryCommandSubject.next({ type: EGalleryCommand.takePicture });
	}

	public pickDocument(): void {
		this.galleryCommandSubject.next({ type: EGalleryCommand.pickDocument });
	}

	public pickImage(): void {
		this.galleryCommandSubject.next({ type: EGalleryCommand.pickImage });
	}

	public pickFile(): void {
		this.galleryCommandSubject.next({ type: EGalleryCommand.pickFile });
	}

	public showForms(): void {
		this.areFormsVisible = !this.areFormsVisible;
	}

	//#endregion
}
